import SiafLiteApiRepository from "../../external/siafLiteApi";

class ContasReceberPagamentosService {
  constructor() {
    this.urlBase = "/financeiro/contas-receber-pagamentos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  removerPagamentos(id, body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${id}/remover-pagamentos-contas-receber`
    ).post(body);
  }
}

export default ContasReceberPagamentosService;
